import { NgClass } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { CheckboxComponent } from "~app/common/components/checkbox/checkbox.component";
import { SkogsvardSelectAtgardItem } from "~app/features/virkeskop/models/skogsvard/createskogsvard-models";
import { RequiredDirective } from "../../../../../common/directives/required/required.directive";
import { AtgardBadgeComponent } from "../../../atgarder/atgard-badge/atgard-badge.component";
import { SkogsvardBadgeComponent } from "../../skogsvard-badge/skogsvard-badge.component";

@Component({
    selector: "rask-skogsvard-select-atgard",
    templateUrl: "./skogsvard-select-atgard.component.html",
    styleUrls: ["./skogsvard-select-atgard.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        RequiredDirective,
        NgSelectComponent,
        FormsModule,
        NgOptionTemplateDirective,
        NgLabelTemplateDirective,
        AtgardBadgeComponent,
        SkogsvardBadgeComponent,
        CheckboxComponent
    ]
})
export class SkogsvardSelectAtgardComponent implements OnInit {

    @Input() listOfAtgarder: SkogsvardSelectAtgardItem[];
    @Input() selectedAtgardGuid?: string;
    @Input() isAtgardRequired?: boolean;
    @Input() showCopyGeometries: boolean;
    @Output() selected = new EventEmitter<SkogsvardSelectAtgardItem>();

    @Output() shouldCopyContractGeometries = new EventEmitter<boolean>();

    protected selectedAtgard: SkogsvardSelectAtgardItem;

    ngOnInit() {
        if (this.listOfAtgarder.length === 1) {
            this.selectedAtgard = this.listOfAtgarder[0];
        } else if (this.selectedAtgardGuid) {
            const requestedAtgard = this.listOfAtgarder.find(x => x.value === this.selectedAtgardGuid);
            this.selectedAtgard = requestedAtgard;
        }

        this.skogsvardAtgardChanged(this.selectedAtgard);
    }

    protected skogsvardAtgardChanged(item: SkogsvardSelectAtgardItem) {
        this.selectedAtgard = item;
        this.selected.emit(this.selectedAtgard);
    }

    protected copyContractGeometriesChanged(value: boolean) {
        this.shouldCopyContractGeometries.emit(value);
    }
}
